/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForResourceDiscoveryExecution extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForResourceDiscoveryExecution");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForResourceDiscoveryExecution.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForResourceDiscoveryExecution>): BackgroundJobPayloadForResourceDiscoveryExecution {
        let obj = Object.assign(new BackgroundJobPayloadForResourceDiscoveryExecution(), model);
        BackgroundJobPayloadForResourceDiscoveryExecution.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForResourceDiscoveryExecution>): BackgroundJobPayloadForResourceDiscoveryExecution {
        if (!model) return null;
        return BackgroundJobPayloadForResourceDiscoveryExecution.newInstance(<BackgroundJobPayloadForResourceDiscoveryExecution> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForResourceDiscoveryExecution) {
        if (!obj) return;

        models.BackgroundJobPayloadForResourceDiscoveryExecution.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForResourceDiscoveryExecution): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForResourceDiscoveryExecution.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    service_account_id: string;

    is_compliance: boolean;

    on_create: boolean;

    event_name: string;

    event_resource: string;

    filter_request: { [key: string]: string; };

}
